import { NODA_FORM_ROUTER_LINK } from '@shared/constants/links';

export const defaultBannerInfo = {
  title: 'articles.defaultBanner.title',
  text: 'articles.defaultBanner.text',
  buttonText: 'articles.defaultBanner.buttonText',
  buttonUrl: NODA_FORM_ROUTER_LINK,
};

export const defaultBannerHeroInfo = {
  title: 'articles.defaultBannerHero.title',
  text: 'articles.defaultBannerHero.text',
  buttonText: 'articles.defaultBannerHero.buttonText',
  buttonUrl: NODA_FORM_ROUTER_LINK,
};
